/* eslint-disable sonarjs/no-duplicate-string */
import { cn, Pill, PillProps } from 'component-library';
import { useTranslation } from 'react-i18next';

import { BenchmarkType, ConservationBenchmark, PopulationDensityBenchmark } from '@/api/rest/resources/types/fact';
import { getStyleForBenchmark } from '@/utils/getStyleForBenchmark';
import { resolveThemeColor } from '@/utils/resolveThemeColor';

export type BenchmarkPillProps = PillProps & {
  benchmarkType: BenchmarkType | ConservationBenchmark | PopulationDensityBenchmark;
};

export const BenchmarkPill = ({ benchmarkType, className, ...delegated }: BenchmarkPillProps) => {
  const { t } = useTranslation();
  const style = getStyleForBenchmark(benchmarkType);

  return (
    <Pill
      className={cn('typography-overline font-bold w-fit rounded px-[9px] py-2', className)}
      style={{
        color: style?.text,
        backgroundColor: style?.primary,
      }}
      {...delegated}
    >
      {t(`global.benchmark.${benchmarkType}`)}
    </Pill>
  );
};

export const DeforestationBenchmarkPill = ({ benchmarkType, className, ...delegated }: BenchmarkPillProps) => {
  const { t } = useTranslation();
  let style = {
    primary: '',
    text: '',
  };

  switch (benchmarkType) {
    case BenchmarkType.unchanged:
      style = {
        primary: resolveThemeColor('benchmark-unchanged-text'),
        text: resolveThemeColor('benchmark-unchanged-background'),
      };
      break;
    case BenchmarkType.very_low:
      style = { primary: resolveThemeColor('success-light'), text: resolveThemeColor('success-dark') };

      break;
    case BenchmarkType.low:
      style = { primary: resolveThemeColor('warning-light'), text: resolveThemeColor('warning-dark') };
      break;
    case BenchmarkType.moderate:
      style = { primary: resolveThemeColor('error-light'), text: resolveThemeColor('error-dark') };
      break;
    case BenchmarkType.high:
      style = { primary: resolveThemeColor('error'), text: resolveThemeColor('error-light') };
      break;
    case BenchmarkType.stable:
      style = { primary: resolveThemeColor('success-light'), text: resolveThemeColor('success-dark') };
      break;
    case BenchmarkType.alerted:
      style = { primary: resolveThemeColor('error-light'), text: resolveThemeColor('error-dark') };
      break;
    default:
      style = { primary: resolveThemeColor('transparent'), text: resolveThemeColor('transparent') };
  }

  return (
    <Pill
      className={cn('typography-overline font-bold w-fit rounded px-[9px] py-2', className)}
      style={{
        color: style?.text,
        backgroundColor: style?.primary,
      }}
      {...delegated}
    >
      {t(`global.benchmark.${benchmarkType}`)}
    </Pill>
  );
};
